import {StyledErrorMessage} from './style'

export const ErrorMessage = ({className, message}: {className?: string; message: string}) => {
    return <StyledErrorMessage className={className}>{message}</StyledErrorMessage>
}
